import { useMutation } from "@apollo/client";
import { evictFields } from "../../../helpers/cache";
import { toast } from "react-toastify";
import { MARK_CUSTOMER, UNMARK_CUSTOMER } from "../customer.queries";
import {
  MarkCustomerMutation,
  MarkCustomerMutationVariables,
} from "../../../__generated__/MarkCustomerMutation";
import {
  UnmarkCustomerMutation,
  UnmarkCustomerMutationVariables,
} from "../../../__generated__/UnmarkCustomerMutation";

export const useToggleCustomerMarked = () => {
  const [mark, { loading: marking }] = useMutation<
    MarkCustomerMutation,
    MarkCustomerMutationVariables
  >(MARK_CUSTOMER, {
    refetchQueries: ["CustomersQuery", "CustomerQuery"],
    update(cache) {
      evictFields(cache, ["customer", "customers"]);
    },
  });
  const [unmark, { loading: unmarking }] = useMutation<
    UnmarkCustomerMutation,
    UnmarkCustomerMutationVariables
  >(UNMARK_CUSTOMER, {
    refetchQueries: ["CustomersQuery", "CustomerQuery"],
    update(cache) {
      evictFields(cache, ["customer", "customers"]);
    },
  });

  const loading = marking || unmarking;

  const toggleMarked = async (id: number, marked: boolean) => {
    if (loading) return;
    try {
      if (marked) {
        const { data } = await mark({ variables: { id } });
        if (data?.markCustomer?.ok) {
          toast.success("Le client a été marqué");
        } else {
          toast.error(data?.markCustomer?.error ?? "Une erreur est survenue");
        }
      } else {
        const { data } = await unmark({ variables: { id } });
        if (data?.unmarkCustomer?.ok) {
          toast.success("Le client a été démarqué");
        } else {
          toast.error(data?.unmarkCustomer?.error ?? "Une erreur est survenue");
        }
      }
    } catch (error: any) {
      toast.error(error?.message ?? "Une erreur est survenue");
    }
  };

  return { toggleMarked, loading };
};
